import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ITaggable, TagType} from "@models";
import {SimTaggingService} from "@services";

export interface DialogData_TagSelectionDialogInput extends MatDialogDataBaseInput {
	taggableObject: ITaggable;
	tagType: TagType;
}

export interface DialogData_TagSelectionDialogOutput extends MatDialogDataBaseOutput {
	updatedTaggableObject: ITaggable;
}

@Component({
	selector: "sim-tag-selection-dialog",
	templateUrl: "./tag-selection-dialog.component.html",
	styleUrls: ["./tag-selection-dialog.component.scss"],
	standalone: false,
})
export class TagSelectionDialogComponent extends BasicMaterialDialog<
	TagSelectionDialogComponent,
	DialogData_TagSelectionDialogInput,
	DialogData_TagSelectionDialogOutput
> {
	protected readonly TagType = TagType;

	constructor(
		_injector: Injector,
		protected _simTaggingService: SimTaggingService,
	) {
		super(_injector);
	}

	ok() {
		this.close({
			action: "ok",
			updatedTaggableObject: this.data.taggableObject,
		});
	}

	updateTaggableObjectTags(tags: string[]) {
		this.data.taggableObject.tagIds = tags;
	}
}
